import React from 'react'

const Button = ({
    color,
    text,
    handleEvent,
    type,
    className
}) => {
  return (
    <button 
    style={{color: color}} 
    onClick={handleEvent} 
    type={type}
    className={className}
    >
      {text} 
    </button>
  )
}

export default Button
